<template>
  <div>
    <form data-vv-scope="step-3-part-1">
      <div class="row mb-3">
        <div class="col-12">
          <h5 class="mb-0">Adjuntar Documentos</h5>
          <LoadFiles
            withClassification
            :step="step"
            @mainFile="addMainFile($event)"
            @additionalFiles="addAdditionalFile($event)"
          />
        </div>
        <small class="text-danger mt-1 ml-5" v-if="error.noMainFile">{{error.noMainFile}}</small>
        <small class="text-danger mt-1 ml-5" v-if="error.onlyPdf">{{error.onlyPdf}}</small>
      </div>
      <div class="row mb-3">
        <div class="col-12">
          <vs-divider />
        </div>
      </div>
    </form>
    <form data-vv-scope="step-3-part-2">
      <div class="row mb-3">
        <div class="col-md-6">
          <vs-select
            class="w-100"
            autocomplete
            label="Relacionado con"
            name="relatedDocumentType"
            v-model="relatedDocument.type"
            v-validate="'required'"
            :danger="errors.has('step-3-part-2.relatedDocumentType')"
            :danger-text="errors.first('step-3-part-2.relatedDocumentType')"
          >
            <vs-select-item
              value="EXP"
              text="Expediente"
            />
            <vs-select-item
              value="SSD"
              text="Proceso SSD"
            />
          </vs-select>
        </div>
        <div class="col-md-6">
          <vs-input
            class="w-100"
            label="Nº Documento"
            name="relatedDocumentNumber"
            v-model="relatedDocument.number"
            v-validate="'required'"
            :danger="errors.has('step-3-part-2.relatedDocumentNumber')"
            :danger-text="errors.first('step-3-part-2.relatedDocumentNumber')"
          />
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-12 d-flex align-items-end justify-content-end">
          <vs-button color="primary" icon="add" v-on:click="addRelatedDocument()">
            Agregar relación
          </vs-button>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-12">
          <vs-table
            class="pb-2 mb-2"
            multiple
            v-model="step.relatedDocumentsSelected"
            no-data-text="No tienes documentos relacionados"
            :data="step.relatedDocuments"
          >
            <template slot="thead">
              <vs-th>Relacionado con</vs-th>
              <vs-th>Nº Documento</vs-th>
            </template>
            <template slot-scope="{data}">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
                <vs-td :data="data[indextr].type">
                  {{ findTypeDocument(tr.type) }}
                </vs-td>
                <vs-td :data="data[indextr].number">
                  {{ tr.number }}
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import WizardStep from '@/febos/chile/dnt/mixins/WizardStep';
import FindTypeDocumentMixin from '@/febos/chile/dnt/mixins/FindTypeDocumentMixin';
import LoadFiles from '@/febos/chile/dnt/components/wizard/companies/60100003-2/components/LoadFiles';

export default {
  mixins: [WizardStep, FindTypeDocumentMixin],
  components: { LoadFiles },
  data() {
    return {
      error: {
        onlyPdf: '',
        noMainFile: ''
      },
      step: {
        mainFile: {},
        additionalFiles: [],
        relatedDocuments: [],
        relatedDocumentsSelected: [],
        ...this.draft
      },
      relatedDocument: {
        type: '',
        number: ''
      }
    };
  },
  computed: {
    thereIsMainFile() {
      return Object.keys(this.step.mainFile)?.length;
    }
  },
  watch: {
    // eslint-disable-next-line func-names
    'step.mainFile.name': function () {
      this.$validator.reset();
    },
  },
  methods: {
    addMainFile(event) {
      this.step.mainFile = event;
    },
    addAdditionalFile(event) {
      this.step.additionalFiles = event;
    },
    onlyPDF() {
      if (this.thereIsMainFile) {
        return this.step.mainFile.mime === 'application/pdf';
      }
      return true;
    },
    async addRelatedDocument() {
      const isValid = await this.validateForm('step-3-part-2');
      if (!isValid) {
        return;
      }
      const row = {
        id: this.relatedDocument.length,
        type: this.relatedDocument.type,
        number: this.relatedDocument.number
      };
      const isSelected = this.step.relatedDocumentsSelected
        .some((relatedDoc) => relatedDoc.id === row.id
          && relatedDoc.type === row.type && relatedDoc.number === row.number);

      if (!isSelected) {
        this.step.relatedDocuments.push(row);
        this.step.relatedDocumentsSelected.push(row);
      } else {
        this.$bvToast.toast(
          'Ya agregaste esta referencia',
          {
            title: '¡HEEEY!',
            variant: 'warning',
            pauseOnHover: true,
            solid: true,
            noAutoHide: true
          }
        );
      }

      this.relatedDocument.type = '';
      this.relatedDocument.number = '';
      await this.$validator.reset();
    },
    async isValid() {
      this.error.onlyPdf = '';
      this.error.mainFile = '';
      const onlyPDF = this.onlyPDF();
      if (!onlyPDF) {
        this.error.onlyPdf = 'El archivo principal solo puede ser formato PDF';
        return false;
      }
      const mainFile = Object.keys(this.step.mainFile).length;
      if (!mainFile) {
        this.error.noMainFile = 'Es obligatorio adjuntar archivos';
        return false;
      }
      const isValid = await this.validateForm('step-3-part-1');
      return isValid;
    }
  }
};

</script>
